var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFolder = function SvgIconFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,28H3a2.908,2.908,0,0,1-3-2.8V2.8A2.908,2.908,0,0,1,3,0h9a2.909,2.909,0,0,1,3,2.8V4.2a1.454,1.454,0,0,0,1.5,1.4H27a2.908,2.908,0,0,1,3,2.8V25.2A2.908,2.908,0,0,1,27,28ZM3,14v9.8a1.455,1.455,0,0,0,1.5,1.4h21A1.455,1.455,0,0,0,27,23.8V14ZM4.5,2.8A1.455,1.455,0,0,0,3,4.2v7H27V9.8a1.455,1.455,0,0,0-1.5-1.4H15a2.909,2.909,0,0,1-3-2.8V4.2a1.454,1.454,0,0,0-1.5-1.4Z",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-folder.6569e654.svg";
export { ForwardRef as ReactComponent };